import { createMaybeSelector } from '@ally/data-selectors';
import { getCustomer } from './base';
export var getFirstName = createMaybeSelector(getCustomer, function (customer) {
    return customer.firstNamePvtEncrypt;
});
export var getStatementPreference = createMaybeSelector(getCustomer, function (customer) {
    return customer.statementDeliveryPreference;
});
export var getCustomerAddress = createMaybeSelector(getCustomer, function (customer) {
    return customer.postAddresses;
});
export var getEtinStatusCode = createMaybeSelector(getCustomer, function (customer) {
    return customer.etinStatusCodePvtEncrypt;
});
//# sourceMappingURL=user.js.map